<div class="auth-shell">
  <div class="auth-card">
    <div class="auth-brand">
      <img src="assets/img/logo.png" class="auth-brand-mark" alt="">
      <span class="auth-brand-word">Fusion</span>
    </div>

    <div class="auth-body">
      @switch (stage) {

        @case ('loading') {
          <p class="auth-lede">{{ 'UTIL.LOADING' | translate }}...</p>
        }

        @case ('invalid') {
          <h2 class="auth-title">{{ 'AUTH.INVITATION_INVALID_TITLE' | translate }}</h2>
          <p class="auth-lede">{{ 'AUTH.INVITATION_INVALID_LEDE' | translate }}</p>
          <div class="auth-links"><a routerLink="/login">{{ 'AUTH.BACK_TO_SIGN_IN' | translate }}</a></div>
        }

        @case ('password') {
          <h2 class="auth-title">{{ 'AUTH.INVITATION_TITLE' | translate }}</h2>
          <p class="auth-lede">{{ 'AUTH.INVITATION_LEDE' | translate:{ username: username } }}</p>

          @if (errorKeys.length) {
            <div class="alert alert-danger">
              @for (key of errorKeys; track key) { <div>{{ key | translate }}</div> }
            </div>
          }

          <form (ngSubmit)="submit()" #inviteForm="ngForm">
            <div class="form-group">
              <label for="password">{{ 'USER.PASSWORD' | translate }}</label>
              <input type="password" class="form-control" id="password" name="password"
                     [(ngModel)]="password" autocomplete="new-password" required
                     [minlength]="minLength" #passwordField="ngModel">
              <p class="auth-note">{{ 'AUTH.PASSWORD_RULE' | translate:{ min: minLength } }}</p>
            </div>

            <div class="form-group">
              <label for="repeat">{{ 'USER.REPEAT_PASSWORD' | translate }}</label>
              <input type="password" class="form-control" id="repeat" name="repeat"
                     [(ngModel)]="repeat" autocomplete="new-password" required>
              @if (mismatch) {
                <div class="alert alert-danger">{{ 'USER.PASSWORD_MISMATCH' | translate }}</div>
              }
            </div>

            <div class="auth-actions">
              <button type="submit" class="btn btn-primary" [disabled]="!canSubmit">
                {{ 'AUTH.INVITATION_CONTINUE' | translate }}
              </button>
            </div>
          </form>

          <p class="auth-note">{{ 'AUTH.MFA_REQUIRED_NOTE' | translate }}</p>
        }

        @case ('enrol') {
          <app-mfa-enrol [challenge]="challenge" [allowedMethods]="allowedMethods"
                         (completed)="onEnrolled($event)"></app-mfa-enrol>
        }

        @case ('done') {
          <div class="auth-done">
            <p class="auth-lede">{{ 'AUTH.SIGNING_IN' | translate }}</p>
          </div>
        }
      }
    </div>
  </div>
</div>
